import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import styled from "styled-components";

import AvatarUpload from "./AvatarUpload";
import Avatar from "../styled/Avatar";
import ProfileForm from "./ProfileForm";
import HeaderWrapper from "../common/HeaderWrapper";

import * as userActions from "../../actions/userActions";
import * as fileActions from "../../actions/fileActions";
import * as modalActions from "../../actions/modalActions";

class AccountSettingsPage extends Component {
  constructor(props) {
    super(props);
    this.state = { editing: false, uploading: false };
  }

  onClickEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  onClickDelete = (e) => {
    e.stopPropagation();
    const data = {
      id: this.props.auth.user.id,
      ...this.props.auth.user,
      avatar: ""
    };
    if (window.confirm(`This action is permanent. Proceed?`)) {
      this.props.actions.deleteFile(this.props.auth.user.avatar);
      this.props.actions.updateUser(data, "account");
    }
  };

  onChangePassword = () => {
    this.props.actions.getUser(this.props.auth.user.id, true);
  };

  handleChangePassword = (password) => {
    const data = {
      ...this.props.user,
      password
    };
    this.props.actions.updateUser(data, true);
  };

  uploadFile = async (files) => {
    const file = files[0];
    const filetype = file.type.split("/")[1];

    file.newName = `${this.props.auth.user.first_name}${this.props.auth.user.last_name}.${filetype}`;

    this.setState({ avatar: file });
  };

  handleSave = async (user) => {
    const data = {
      id: this.props.auth.user._id,
      full_name: `${user.first_name} ${user.last_name}`,
      tech_id: `${user.first_name[0].toUpperCase()}${user.last_name.toUpperCase()}`,
      ...user
    };

    if (this.state.avatar) {
      await this.props.actions.uploadFile(this.state.avatar);
      data.avatar = this.props.file;
    }

    await this.props.actions.updateUser(data, "account");
  };

  handleCancel = () => {
    this.props.history.push("/app/dashboard");
  };

  render() {
    const {
      auth: { user },
      isMobile
    } = this.props;

    const avatar = (
      <div className="profile profile-avatar">
        <Avatar user={user} avatar={user.avatar} size="lg" />
        <div className="avatar-upload-options">
          <div id="edit-profile-avatar">Edit</div>
          {typeof user.avatar === "string" && user.avatar.length > 0 && (
            <div
              id="delete-profile-avatar"
              role="presentation"
              onKeyDown={() => {}}
              onClick={this.onClickDelete}
            >
              Delete
            </div>
          )}
        </div>
      </div>
    );

    return (
      <>
        <HeaderWrapper
          breadcrumbs={[{ label: "Edit Profile" }]}
          onClickEdit={this.onClickEdit}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <Grid>
            <AvatarUpload onDrop={this.uploadFile} content={avatar} />
            <ProfileForm
              user={user}
              editing={this.state.editing}
              saving={this.props.savingUser}
              onSave={this.handleSave}
              onCancel={this.handleCancel}
              onChangePassword={this.onChangePassword}
              handleChangePassword={this.handleChangePassword}
            />
          </Grid>
        </div>
      </>
    );
  }
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  grid-gap: 15px;
  /* USER PROFILE PAGE */
  .avatar-upload {
    width: 150px;
    height: 150px;
    margin: 20px 10px;
    align-self: flex-start;
  }
  .profile-avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .avatar-upload-options {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      & > * {
        line-height: 100%;
        text-transform: uppercase;
        font-weight: 900;
        font-family: "Roboto";
        font-size: 14px;
        letter-spacing: 2px;
        width: auto;
        padding: 1.5rem 0.5rem;
        transition: 150ms ease-in-out;
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
  .profile.avatar {
    display: flex;
    justify-content: center;
    position: relative;
    img {
      height: 120px !important;
      width: 120px !important;
      border-radius: 50%;
    }
    svg {
      font-size: 150px;
    }
    span {
      visibility: hidden;
      font-size: 18px;
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      line-height: 100%;
      text-transform: uppercase;
      font-weight: 900;
      font-family: "Roboto";
      font-size: 13px;
      letter-spacing: 2px;
    }
    .avatar {
      height: auto;
    }
    .avatar-upload-options {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      visibility: hidden;
      opacity: 0;
      transition: 250ms ease;
      & > * {
        line-height: 100%;
        text-transform: uppercase;
        font-weight: 900;
        font-family: "Roboto";
        font-size: 14px;
        letter-spacing: 2px;
        width: auto;
        padding: 1.5rem 0.5rem;
        transition: 150ms ease-in-out;
        &:hover {
          opacity: 0.7;
        }
      }
    }
    &:hover {
      cursor: pointer;
      svg,
      img {
        transition: 0.5s ease;
        opacity: 0.5;
      }
      img {
        filter: blur(1px);
      }
      span {
        color: $theme_dark_grey;
        visibility: visible;
      }
      .avatar-upload-options {
        visibility: visible;
        opacity: 1;
      }
    }
  }
  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 3fr;
    .avatar-upload {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
  }
`;

AccountSettingsPage.propTypes = {
  actions: PropTypes.object,
  auth: PropTypes.object,
  user: PropTypes.object,
  file: PropTypes.string,
  savingUser: PropTypes.bool,
  isMobile: PropTypes.bool,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    user: state.reducers.user,
    file: state.reducers.file,
    savingUser: state.reducers.savingUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...userActions, ...fileActions, ...modalActions },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(AccountSettingsPage);
